import { render, staticRenderFns } from "./FlagDocRenderer.vue?vue&type=template&id=72c2a146&"
import script from "./FlagDocRenderer.vue?vue&type=script&lang=js&"
export * from "./FlagDocRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports